import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { listConnectors } from '@/api/content/connector'
import { ConnectorPage } from '@/components/ConnectorPage'
import { isConversationWorkspaceAvailable } from '@/features/conversation/availability'
import { LegacyContentSettingsBridge } from '@/features/settings/LegacyContentSettingsBridge'

export const Route = createFileRoute('/_auth/$orgSlug/content/connector/')({
  validateSearch: z.object({
    connectorId: z.coerce.number().int().min(1).optional().catch(undefined)
  }),
  beforeLoad: ({ context, params }) => {
    if (!context.user.userOrgProfile?.enabled_features.content_connectors) {
      throw redirect({
        to: '/$orgSlug/content/text',
        params: { orgSlug: params.orgSlug }
      })
    }
  },
  loader: ({ context }) =>
    isConversationWorkspaceAvailable(context.user.userOrgProfile?.enabled_features)
      ? Promise.resolve({ connectors: [] })
      : listConnectors(),
  head: () => ({ meta: [{ title: 'Global Content - Snowvault' }] }),
  component: ConnectorPageRoute
})

function ConnectorPageRoute() {
  const { orgSlug } = Route.useParams()
  const navigate = Route.useNavigate()
  const { connectors } = Route.useLoaderData()
  const { connectorId } = Route.useSearch()
  const { userOrgProfile } = Route.useRouteContext().user
  if (!userOrgProfile) return null
  if (isConversationWorkspaceAvailable(userOrgProfile.enabled_features)) {
    return (
      <LegacyContentSettingsBridge
        orgSlug={orgSlug}
        kind="connectors"
        {...(connectorId !== undefined ? { contentItemId: connectorId } : {})}
      />
    )
  }
  return (
    <ConnectorPage
      breadcrumbs={[{ label: 'Global Content' }, { label: 'Connectors' }]}
      connectors={connectors}
      userOrgProfile={userOrgProfile}
      initialConnectorId={connectorId}
      onClearConnectorId={connectorId !== undefined ? () => void navigate({ search: {} }) : undefined}
    />
  )
}
